import axios from "axios";
import { toast } from "react-toastify";
import { format } from "date-fns";

import { Answer, Feedback, SearchFeedbacksFilter } from "./Feedback";
import { getTicketPrettyId } from "../tickets/ticketsApi";
import { mapApiPaginationDetails, mapToApiPagination } from "../../common/api/paginationHelper";
import { convertISOStringToDate } from "../../common/utils/dateHelper";

const FEEDBACK_API_URL = `${process.env.REACT_APP_API_BASE_URL}/feedback`;

export const fetchFeedbackById = async (feedbackId: string) => {
  try {
    const response = await axios.get(`${FEEDBACK_API_URL}/${feedbackId}`);
    const feedback = mapApiFeedback(response.data);
    return feedback;
  } catch (error) {
    return undefined;
  }
};

export const submitFeedback = async (feedback: Feedback) => {
  await axios.put(FEEDBACK_API_URL, feedback);
  toast.success("Feedback-ul a fost trimis cu succes. Îți mulțumim!");
};

export const searchFeedbacks = async (filter: SearchFeedbacksFilter) => {
  const payload = {
    departmentId: filter.departmentId ? parseInt(filter.departmentId) : undefined,
    ticketId: filter.ticketId ? parseInt(filter.ticketId) : undefined,
    answerValue: filter.answerValue ?? undefined,
    agentId: filter.agentId,
    sortParameters: filter.sortParameters,
    ...mapToApiPagination(filter),
  };
  const response = await axios.post(`${FEEDBACK_API_URL}/search-all`, payload);
  const pagination = mapApiPaginationDetails(response.data);
  const feedbacks: Feedback[] = response.data.items.map(mapApiFeedback);

  return {
    pagination,
    feedbacks,
  };
};

export const mapApiFeedback = (apiFeedback: any): Feedback => {
  const created = convertISOStringToDate(`${apiFeedback.created}Z`)!;

  return {
    id: apiFeedback.id,
    departmentId: `${apiFeedback.departmentId}`,
    ticketId: `${apiFeedback.ticketId}`,
    prettyTicketId: getTicketPrettyId(apiFeedback.ticketId),
    userId: apiFeedback.userId,
    userName: apiFeedback.userName,
    agentId: apiFeedback.agentId,
    agentName: apiFeedback.agentName,
    question: apiFeedback.question,
    answer: apiFeedback.answer ? mapApiAnswer(apiFeedback.answer) : undefined,
    createdPretty: format(created, "dd/MM/yyyy HH:mm"),
  };
};

export const mapApiAnswer = (apiAnswer: any): Answer => ({
  value: apiAnswer.value,
  label: apiAnswer.label,
  description: apiAnswer.description,
});
